import ServicePlanBooking from './components/ServicePlanBooking.vue'

Vue.component('service-plan-booking', ServicePlanBooking)

const servicePlanBookingVueEnvironment = new Vue({
    delimiters: ['[%', '%]'],
    el: '.js_servicePlanBookingVue',
});